<template>
  <div class="signlog">
    
      <section class="toolbar">
         <div class="toolbar-container">
            <a href="#"><img src="/static/images/menu.png"></a>
            <h1>Logs</h1>
         </div>
      </section>
      <section class="change-duty-status">
         <div class="change-duty-status-container">
            <form id="signForm" method="post">
               <div class="checkbox123">
                  <label>
                  <input type="hidden" id="sign_image" name="sign_image"/>
                  <input type="checkbox" value="1" id = "chk_agree"/>
                  <!--<span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>-->
                  I certify these entries are true and correct
                  </label>
               </div>
               <div class="form-group">
                  <!--<textarea class="form-control" rows="5" id="comment"></textarea>-->
                  <canvas id="signature-pad" class="signature-pad col-md-12" height=200></canvas>
                  <label for="comment" class="pull-right" id="clear">Clear Signature</label>
               </div>
            </form>
         </div>
      </section>
      <section class="submit-section">
         <button type="button" class="btn btn-default" id = "save">Save</button>
         <!-- <button type="submit" class="btn btn-default" id = "cancel">Cancel</button> -->
      </section>
  </div>
</template>

<script>

import SignaturePad from 'signature_pad';

export default {
  name: "signlog",
  data: () => ({
    //signaturePad : null ,
  }),
  mounted: function() {
      var self=this;
      var signaturePad = new SignaturePad(
        document.getElementById("signature-pad"),
        {
          backgroundColor: "rgba(255, 255, 255, 0)",
          penColor: "rgb(0, 0, 0)"
        }
      );
      var saveButton = document.getElementById("save");
      var clearButton = document.getElementById("clear");

      saveButton.addEventListener("click", function(event) {
        // Send data to server instead...
        //document.getElementById('sig_img').src = data;
        //console.log(data)
        self.sender(signaturePad);
        // $("#signForm").submit();
        //window.open(data);
      });

      clearButton.addEventListener("click", function(event) {
        signaturePad.clear();
      });
  
  },
  beforeDestroy: function() {},
  methods: {
    sender: function(signPad) {
      var self=this;
      if (!$("#chk_agree").prop("checked")) {
        alert("Please accept 'Certify this Entries and Accept' Statment");
        return;
      }
      if (signPad.isEmpty()) {
        alert("Please Sign Log and then Submit");
        return;
      }
      var dataImage = signPad.toDataURL("image/png");
      $("#sign_image").val(dataImage);
      self.$config.loading=true;
      $.ajax({
        url: self.$config.API+"/v1/operator/upload-sign",
        type: "POST",
	      data:{"sign_image":dataImage},
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },timeout: 10000,
        success: function(data) {self.$config.loading=false;

          if ( data.status == "success" ) {
              console.log("uploaded sign successfully");
              self.$router.push("/operator/home-page");	   	
          } else {
            console.log("uploaded sign failed");
          }

        },
        error: function(jqXHR, exception, textstatus) {self.$config.loading=false;
          //if session expired
         if(textstatus==="timeout") {
            alert("Request timeout");
        } else if ( jqXHR.responseJSON.code == 401 ) {
            self.$router.push(
              "/v1/operator/login"
            )  
          } else if ( jqXHR.responseJSON.code == 400 ) {
            alert(jqXHR.responseJSON.message);
          }
            
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/signlog.vue